var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center ma-5 pa-5"},[_c('v-progress-circular',{attrs:{"size":"120","width":"7","color":"grey","indeterminate":""}},[_vm._v(_vm._s(_vm.caption))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }